import React from 'react';

function CheckboxInput({
    label, // Can be JSX for complex labels with links
    icon = null,
    id,
    name,
    checked,
    value, // Add value to destructured props
    onChange,
    required = false,
    wrapperClassName = "form-check", // Default to "form-check"
    disabled = false
}) {
    return (
        <div className={wrapperClassName}>
            <input
                type="checkbox"
                className="form-check-input"
                id={id}
                name={name}
                checked={checked}
                value={value} // Pass the value to the native input element
                onChange={onChange}
                required={required}
                disabled={disabled}
            />
            <label className="form-check-label ms-2" htmlFor={id}>
                {
                    icon ? <>
                        {icon + ' '}{label}
                    </> : <>
                        {label}
                    </>
                }

            </label>
        </div>
    );
}

export default CheckboxInput;